<h1 class="page-title">
  {{title}}
</h1>
